import Vue from 'vue'
import _ from 'underscore'

import utils from '@/lib/utils'
import NC from '@/lib/notification-center'

import defaultScroll from '@/mixins/default_scroll'

export default  {
  name: 'modal',
  mixins: [defaultScroll],
  props: [],
  data() {
    return {
      preloaded: false,
      project: false
    }
  },

  computed: {
    assetPath: function() {
      return `/static/${this.project.id}/`;
    }
  },

  mounted() {
    this.project = this.store.currentModal;

    this.preload(this._preloaded);

    NC.emit('modal:opened');
  },

  destroyed() {
    NC.emit('modal:closed');
    if(this.delayScrollId) clearTimeout(this.delayScrollId);
  },

  methods: {

    preload(callback) {

      const imagesUrl = _.chain(this.project.sections).where({'type': 'image'}).pluck('url').map((img) => {
        return this.assetPath + img;
      }).value();

      if (imagesUrl.length) {
        utils.loadImages(imagesUrl, callback);
      } else {
        callback();
      }
    },

    _preloaded() {
      this.preloaded = true;

      this.delayScrollId = _.delay(_.bind(function() {
        this.initScroll(this.$el);
        this.delayScrollId = false;
      }, this), 300);
    },

    _onClickClose() {
      this.store.showModal = false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/modal/modal.component.js